/* eslint-disable */
import { useState } from "react";
import { Link } from "react-router-dom";
import { FilterChart, search } from "../../_components/Imagepath";
import DatePicker from "react-datepicker";

const AddVendor = ({ show, setShow, onApply }) => {
  const [filters, setFilters] = useState({
    customers: [],
    startDate: new Date(),
    endDate: new Date(),
    statuses: [],
  });

  const handleCheckboxChange = (e, key) => {
    const { value, checked } = e.target;
    setFilters((prev) => {
      const updated = new Set(prev[key]);
      if (checked) {
        updated.add(value);
      } else {
        updated.delete(value);
      }
      return {
        ...prev,
        [key]: Array.from(updated),
      };
    });
  };

  const applyFilter = () => {
    onApply(filters);
    setShow(false);
  };

  return (
    <div className={`toggle-sidebar ${show ? "open-filter" : ""}`}>
      <div className="sidebar-layout-filter">
        <div className="sidebar-header">
          <h5>Filter</h5>
          <Link
            to="#"
            className="sidebar-closes"
            onClick={() => setShow(!show)}
          >
            <i className="fa-regular fa-circle-xmark" />
          </Link>
        </div>
        <div className="sidebar-body">
          <form onSubmit={(e) => e.preventDefault()} autoComplete="off">
            {/* Customer */}
            <div className="accordion" id="accordionMain1">
              <div className="card-header-new" id="headingOne">
                <h6 className="filter-title">
                  <Link
                    to="#"
                    className="w-100"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                  >
                    Customer
                    <span className="float-end">
                      <i className="fa-solid fa-chevron-down" />
                    </span>
                  </Link>
                </h6>
              </div>
              <div
                id="collapseOne"
                className="collapse show"
                aria-labelledby="headingOne"
              >
                <div className="card-body-chat">
                  <div className="form-custom">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search here"
                    />
                    <span>
                      <img src={search} alt="img" />
                    </span>
                  </div>
                  <div className="selectBox-cont">
                    {[
                      "Brian Johnson",
                      "Russell Copeland",
                      "Greg Lynch",
                      "John Blair",
                    ].map((name) => (
                      <label className="custom_check w-100" key={name}>
                        <input
                          type="checkbox"
                          value={name}
                          checked={filters.customers.includes(name)}
                          onChange={(e) => handleCheckboxChange(e, "customers")}
                        />
                        <span className="checkmark" /> {name}
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Select Date */}
            <div className="accordion" id="accordionMain2">
              <div className="card-header-new" id="headingTwo">
                <h6 className="filter-title">
                  <Link
                    to="#"
                    className="w-100 collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                  >
                    Select Date
                    <span className="float-end">
                      <i className="fa-solid fa-chevron-down" />
                    </span>
                  </Link>
                </h6>
              </div>
              <div
                id="collapseTwo"
                className="collapse"
                aria-labelledby="headingTwo"
              >
                <div className="card-body-chat">
                  <div className="input-block mb-3">
                    <label className="form-control-label">From</label>
                    <div className="cal-icon">
                      <DatePicker
                        className="datetimepicker form-control"
                        selected={filters.startDate}
                        onChange={(date) =>
                          setFilters((prev) => ({ ...prev, startDate: date }))
                        }
                      />
                    </div>
                  </div>
                  <div className="input-block mb-3">
                    <label className="form-control-label">To</label>
                    <div className="cal-icon">
                      <DatePicker
                        className="datetimepicker form-control"
                        selected={filters.endDate}
                        onChange={(date) =>
                          setFilters((prev) => ({ ...prev, endDate: date }))
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* By Status */}
            <div className="accordion" id="accordionMain3">
              <div className="card-header-new" id="headingThree">
                <h6 className="filter-title">
                  <Link
                    to="#"
                    className="w-100 collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                  >
                    By Status
                    <span className="float-end">
                      <i className="fa-solid fa-chevron-down" />
                    </span>
                  </Link>
                </h6>
              </div>
              <div
                id="collapseThree"
                className="collapse"
                aria-labelledby="headingThree"
              >
                <div className="card-body-chat">
                  <div className="form-custom">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search here"
                    />
                    <span>
                      <img src={search} alt="img" />
                    </span>
                  </div>
                  <div className="selectBox-cont">
                    {[
                      "All Invoices",
                      "Paid",
                      "Overdue",
                      "Draft",
                      "Recurring",
                      "Cancelled",
                    ].map((status) => (
                      <label className="custom_check w-100" key={status}>
                        <input
                          type="checkbox"
                          value={status}
                          checked={filters.statuses.includes(status)}
                          onChange={(e) => handleCheckboxChange(e, "statuses")}
                        />
                        <span className="checkmark" /> {status}
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <button
              type="button"
              className="d-inline-flex align-items-center justify-content-center btn w-100 btn-primary"
              onClick={applyFilter}
            >
              <span>
                <img src={FilterChart} className="me-2" alt="Generate report" />
              </span>
              Apply Filter
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddVendor;
